import { ComponentMultiStyleConfig } from '@chakra-ui/react';

const FormErrorTheme: ComponentMultiStyleConfig = {
  parts: ['text', 'icon'],
  baseStyle: () => ({
    text: {
      marginTop: '4px',
      fontSize: 'md',
      fontWeight: 'normal',

      _light: {
        color: 'red.darker'
      },
      _dark: {
        color: 'red.base'
      }
    },
    icon: {
      _light: {
        color: 'red.darker'
      },
      _dark: {
        color: 'red.base'
      }
    }
  })
};

export default FormErrorTheme;
